import { render } from "./BatchUploadUpdateUsers.vue?vue&type=template&id=3f4fb78f"
import script from "./BatchUploadUpdateUsers.vue?vue&type=script&lang=js"
export * from "./BatchUploadUpdateUsers.vue?vue&type=script&lang=js"
script.render = render

export default script